import type { AppLocale, DeepPartialMessageTree } from "@airange/shared/i18n-common";

export const microLabNoticeMessages: Record<AppLocale, DeepPartialMessageTree> = {
  "zh-CN": {
    microLab: {
      notices: {
        libraryWorkspace:
          "这里承接共享方案浏览与复用主链：只展示已审核通过的共享版本，详情与引用/克隆都在方案域内完成。",
        schemesPrivateWorkspace:
          "这里是教员方案主工作台：只展示当前账号拥有的方案，继续通过“管理版本”进入独立版本工作面维护环境、手册和结构化步骤。",
        schemesPublicWorkspace:
          "这里直接承接共享方案浏览与复用主链：只展示已审核通过的共享版本，详情与引用/克隆都在方案域内完成，不再保留独立“共享实验库”入口。",
        schemesScopes: {
          mine: "这里是教员方案主工作台：只展示当前账号拥有的方案，继续通过“管理版本”进入独立版本工作面维护环境、手册和结构化步骤。",
          shared_with_me:
            "这里展示 direct share grant 明确共享给当前账号的方案；当前账号只能读取与进入版本工作面查看，写入仍由后端权限裁决。",
          public:
            "这里直接承接共享方案浏览与复用主链：只展示已审核通过的共享版本，详情与引用/克隆都在方案域内完成。",
          all: "这里是 platform_manager 专用的全量治理视图，展示所有 owner 的实验方案；普通教员不能访问该 scope。",
        },
        schemeVersionsWorkspace:
          "版本已经从方案抽屉中拆出，后续请在这个独立工作面维护草稿版本、环境资产与结构化步骤。",
        invalidSchemeVersionContext: "当前地址里的方案 ID 无效，无法加载方案版本工作面。",
        schemeReviewsWorkspace:
          "这里独立承接管理员共享审核工作面：待审核、已通过、已驳回和已下线记录统一在这里维护，并作为 `/schemes` 域下唯一保留的共享治理入口。",
        releasesWorkspace:
          "这里承接发布主链：选择明确的方案版本、设置可见范围与手册可见性、选定目标成员，再把发布从草稿推进到已发布、已关闭和已归档。",
        releaseDetailWorkspace:
          "这里独立承接单条发布的发布运营：上半区固定展示发布摘要与快照，下半区直接管理目标成员与已形成的实验实例，不再让全局实例页承担单发布运营职责。",
        releaseAllMembersDynamicVisibility:
          "当前发布面向全部成员可见，这里不再伪造固定目标成员清单；成员范围会随当前启用成员动态变化。",
        runsWorkspace:
          "这里承接跨发布实例审计主链：只查看已经形成的学生实验实例，把运行状态、判定结果、check 过程、历史轮次与人工改判留痕集中到同一页。",
        invalidReleaseContext: "当前地址里的发布 ID 无效，无法加载发布详情。",
      },
    },
  },
  en: {
    microLab: {
      notices: {
        libraryWorkspace:
          "This workspace carries shared-scheme browsing and reuse inside the scheme domain. Only approved shared versions appear here, with details and reference or clone actions.",
        schemesPrivateWorkspace:
          "This is the instructor scheme workspace. It only shows schemes owned by the current account and continues into the dedicated version workspace for environments, manuals, and structured steps.",
        schemesPublicWorkspace:
          "This page now carries the shared-scheme browsing and reuse main path directly inside the scheme domain. Only approved shared versions appear here, and the old standalone shared-library entry is gone.",
        schemesScopes: {
          mine: "This is the instructor scheme workspace. It only shows schemes owned by the current account and continues into the dedicated version workspace for environments, manuals, and structured steps.",
          shared_with_me:
            "This view shows schemes explicitly shared with the current account through direct grants. The current account can read them and inspect versions; write permission remains enforced by the backend.",
          public:
            "This view carries shared-scheme browsing and reuse inside the scheme domain. Only approved shared versions appear here, with details and reference or clone actions.",
          all: "This platform_manager-only governance view lists schemes across all owners. Regular instructors cannot access this scope.",
        },
        schemeVersionsWorkspace:
          "Versions have moved out of the scheme drawer. Continue maintaining draft versions, environment assets, and structured steps in this dedicated workspace.",
        invalidSchemeVersionContext:
          "The scheme ID in the current URL is invalid, so the scheme version workspace cannot be loaded.",
        schemeReviewsWorkspace:
          "This page independently handles the admin shared-review workspace. Pending, approved, rejected, and offline records are maintained here as the only shared-governance entry kept under `/schemes`.",
        releasesWorkspace:
          "This page carries the release main path: choose an exact scheme version, set visibility and manual exposure, select target members, then move the release from draft to published, closed, and archived.",
        releaseDetailWorkspace:
          "This page independently handles release operations for one release. The top section fixes the release summary and snapshot, while the lower section directly manages target members and formed run instances instead of pushing that work back to the global runs page.",
        releaseAllMembersDynamicVisibility:
          "This release is visible to all members, so the page does not fabricate a fixed target-member list. The visible scope follows the current active members dynamically.",
        runsWorkspace:
          "This page carries the cross-release run-audit main path: it only inspects already-formed learner lab instances and brings status, results, checks, attempt history, and manual override audit into one place.",
        invalidReleaseContext:
          "The release ID in the current URL is invalid, so the release detail page cannot be loaded.",
      },
    },
  },
  ja: {
    microLab: {
      notices: {
        libraryWorkspace:
          "この作業領域では、プラン領域内で共有プランの閲覧と再利用を扱います。承認済みの共有バージョンだけを表示し、詳細確認と参照または複製をここで完結します。",
      },
    },
  },
};
